import React from 'react';
import headWorkIcon from '../../../images/member-page/headWork.svg';
import { HeaderWrap } from './style';
import { SelectValue } from 'antd/lib/select';
import { LangEnum } from '../../IPOConfig/config';
import { ITag } from '../../Tag/tag';
import { IPOSelect } from '../../../styles/components/IPOSelect';
import { IPOAvatar } from '../../../styles/components/IPOAvatar';
import { IAccount } from '../../Account';
import { TagCard } from '../../Tag';
interface Props {
	userInfo: IAccount;
	majorTag: ITag[];
	teamTag: ITag[];
	lang: LangEnum;
	changeLang: (lang: LangEnum) => void;
	BASEURL: string;
}
export const MemberHeader = ({ userInfo, lang, changeLang, teamTag, majorTag, BASEURL }: Props) => {
	return (
		<HeaderWrap>
			<div className="user-info-dom">
				<img className="head-work-icon" src={headWorkIcon}></img>
				<IPOSelect
					className="select-local"
					value={lang}
					onChange={(node: SelectValue) => {
						changeLang(node as LangEnum);
					}}
					style={{ width: '88px' }}
					optionList={[
						{
							value: LangEnum.ZH,
							label: '中文',
						},
						{
							value: LangEnum.EN,
							label: 'English',
						},
					]}></IPOSelect>
				<IPOAvatar
					size={120}
					info={{
						avatar: userInfo.avatar,
						name: userInfo.name,
						id: userInfo.id,
						name2: userInfo.name2,
						mobile: userInfo.mobile,
						baseUrl: BASEURL,
					}}
				/>
				<div className="user-info-ul">
					<div className="info-name">
						{userInfo.name ? userInfo.name : userInfo.name2 ? userInfo.name2 : userInfo.mobile}
						{userInfo.name2 && <span>({userInfo.name2})</span>}
					</div>
					<div className="info-li">
						手机:<span className="info--tip">{userInfo.mobile}</span>
					</div>
					<div className="info-li">
						邮箱:<span className="info--tip">{userInfo.email}</span>
					</div>
					<div className="info-li tag">
						专业:
						<div className="tag-wrap">
							{majorTag?.map(item => {
								return <TagCard key={item.id} tag={item} baseUrl={BASEURL ?? ''} size={20} />;
							})}
						</div>
					</div>
					<div className="info-li tag">
						团队:
						<div className="tag-wrap">
							{teamTag?.map(item => {
								return <TagCard key={item.id} tag={item} baseUrl={BASEURL ?? ''} size={20} />;
							})}
						</div>
					</div>
				</div>
			</div>
		</HeaderWrap>
	);
};
